// This script to manage data flow from Paperform form submissions to GTM.
window.addEventListener("message", (event) => {
  if (typeof event.data != "string" ||
    !event.data.startsWith("paperform:")
  )
    return;

  try {
    decodedData = JSON.parse(event.data.substring(10));
  } catch (e) {
    return;
  }

  if (
    !decodedData.hasOwnProperty("action") ||
    decodedData.action != "submission"
  )
    return;

  window.dataLayer.push({
    event: "request_form_submitted",
    formLocation: window.location.pathname,
  });
});